module.exports = __webpack_public_path__ + "static/media/Booklet-Ultrasounds.fa1b7b85.pdf";